module.exports = __webpack_public_path__ + "img/TeamComic_051.151863f9.png";